<button #originRef (click)="showPopover()" [class.bg-hover]="dropdownOpen" class="button" mat-icon-button type="button"
  [matBadge]="unreadCount" [matBadgeHidden]="unreadCount == 0" [matBadgePosition]="'below before'"
  matBadgeColor="accent">
  <mat-icon color="primary" svgIcon="mat:notifications_active"></mat-icon>
</button>